import useDictionary from '../hooks/useDictionary';
import '../css/ticker.css';

const Ticker = ({
  speed = 60,
  separator = '✦',
}) => {

    const dictionary = useDictionary();

    const items = [
    dictionary.TICK_MADE_IN_PL,
    dictionary.TICK_PREMIUM_FABRICS,
    dictionary.TICK_CUSTOM_ORDERS,
    dictionary.TICK_EU_AND_USA_SHIP,
    dictionary.TICK_SINCE_2007,
    dictionary.TICK_RETURNS,
    dictionary.TICK_B2B
  ];

  const doubled = [...items, ...items];

  return (
    <div className="ticker-wrap">
      <div
        className="ticker-track"
        style={{ animationDuration: `${speed}s` }}
      >
        {doubled.map((item, i) => (
          <span key={i} className="ticker-item">
            {item}
            <span className="ticker-sep">{separator}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
